<template>
  <Modal :value="value" :title="modalTitle" :mask-closable="false" @on-visible-change="onVisibleChange">
    <p class="schedule-desc">可单选或同时勾选面试与试讲，分别选择日期时间。</p>
    <div class="schedule-box">
      <div class="schedule-row">
        <Checkbox v-model="useInterview">面试</Checkbox>
        <DatePicker v-if="useInterview" type="datetime" format="yyyy-MM-dd HH:mm" :value="interviewTime"
          placeholder="选择面试日期与时间" transfer style="width: 260px" @on-change="interviewTime = $event"></DatePicker>
      </div>
      <div class="schedule-row">
        <Checkbox v-model="useDemo">试讲</Checkbox>
        <DatePicker v-if="useDemo" type="datetime" format="yyyy-MM-dd HH:mm" :value="demoTime"
          placeholder="选择试讲日期与时间" transfer style="width: 260px" @on-change="demoTime = $event"></DatePicker>
      </div>
    </div>
    <p class="schedule-warn" v-if="!useInterview && !useDemo">请至少勾选「面试」或「试讲」</p>
    <div slot="footer">
      <Button type="text" @click="close">取消</Button>
      <Button type="primary" :loading="loading" :disabled="!useInterview && !useDemo" @click="ok">确认安排</Button>
    </div>
  </Modal>
</template>
<script>
import { tchName } from '../recruitConst'

export default {
  name: 'RecruitScheduleModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: null
    },
    kind: {
      type: String,
      default: 'both'
    }
  },
  data () {
    return {
      useInterview: true,
      useDemo: true,
      interviewTime: '',
      demoTime: '',
      loading: false
    }
  },
  computed: {
    modalTitle () {
      let name = tchName(this.row)
      return '安排面试/试讲' + (name ? ' - ' + name : '')
    }
  },
  watch: {
    value (val) {
      if (val) {
        let row = this.row || {}
        this.useInterview = this.kind === 'interview' || this.kind === 'both'
        this.useDemo = this.kind === 'demo' || this.kind === 'both'
        this.interviewTime = row.interviewTime || ''
        this.demoTime = row.demoTime || ''
        this.loading = false
      }
    }
  },
  methods: {
    onVisibleChange (val) {
      if (!val) {
        this.close()
      }
    },
    close () {
      this.$emit('input', false)
    },
    ok () {
      if (!this.row) {
        return
      }
      if (!this.useInterview && !this.useDemo) {
        this.$Message.error('请至少选择「面试」或「试讲」')
        return
      }
      if (this.useInterview && !this.interviewTime) {
        this.$Message.error('请选择面试时间')
        return
      }
      if (this.useDemo && !this.demoTime) {
        this.$Message.error('请选择试讲时间')
        return
      }
      let params = {tchId: this.row.tchId}
      if (this.useInterview) {
        params.interviewTime = this.interviewTime
      }
      if (this.useDemo) {
        params.demoTime = this.demoTime
      }
      this.loading = true
      this.$http.post('/tchRecruit/interview/schedule', params, {silent: true}).then((res) => {
        if (res && res.status === 'ok') {
          this.$Message.success('已安排')
          this.close()
          this.$emit('on-success')
        } else {
          this.$Message.error((res && res.msg) || '安排失败')
        }
      }).catch(() => {}).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.schedule-desc { margin-bottom: 12px; font-size: 13px; color: #808695; }
.schedule-box { padding: 12px; border: 1px solid #e9eaec; border-radius: 4px; background: #f8f8f9; }
.schedule-row { display: flex; align-items: center; min-height: 36px; }
.schedule-row + .schedule-row { margin-top: 10px; padding-top: 10px; border-top: 1px solid #e9eaec; }
.schedule-row .ivu-checkbox-wrapper { width: 70px; }
.schedule-warn { margin-top: 8px; font-size: 12px; color: #ff9900; }
</style>



// WEBPACK FOOTER //
// RecruitScheduleModal.vue?fda184aa